import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestStatus } from 'src/enums/request-status';
import { sendDesignStatusAsync } from './actionStatus';
import { FetchState } from 'src/interfaces/requestState';

const initialState: FetchState = {
    requestStatus: RequestStatus.None,
    error: '',
};

export const statusSlice = createSlice({
    name: 'status',
    initialState,
    reducers: {},

    extraReducers: builder => {
        // @ts-ignore
        builder
            .addCase(sendDesignStatusAsync.pending, state => {
                state.requestStatus = RequestStatus.Loading;
            })
            .addCase(sendDesignStatusAsync.fulfilled, state => {
                state.requestStatus = RequestStatus.Completed;
            })
            .addCase(sendDesignStatusAsync.rejected, (state, action: PayloadAction<string>) => {
                state.requestStatus = RequestStatus.Failed;
                state.error = action.payload;
            });
    },
});
export default statusSlice.reducer;
